<template>
  <div class="clear" />
  <div class="middle">
    <div class="cont">
      <h1 class="pageTitle">事業内容</h1>
      <div class="lbox2">
        <a href="/service" class="menuBtn">Webサイト構築</a>
        <div class="menuBtnActive">管理システム構築</div>
        <a href="/service3" class="menuBtn">ECパッケージAjax版</a>
      </div>
      <div class="rbox2">
        <div class="service clear">
          <h2 class="subTitle">管理システム構築の流れ</h2>
          <table>
            <tr>
              <td>
                <a href="/service">WEBサイト構築</a>の流れと同様です。
              </td>
            </tr>
          </table>
        </div>

        <br />
        <div class="service clear">
          <h2 class="subTitle">管理システム</h2>
          <div class="chapt clear">
            <table>
              <tr>
                <th><a name="t01">1.在庫管理</a></th>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li>通常の仕入れ、受注、棚卸による商品在庫数管理</li>
                    <li>ECサイトと連携する在庫管理</li>
                  </ul>
                </td>
              </tr>
            </table>
            <table>
              <tr>
                <th><a name="t01">2.顧客管理</a></th>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li>顧客情報の登録・編集・検索</li>
                    <li>お客様独自の顧客管理機能の実装</li>
                    <li>既存他システムとの連携(仕入れ、受注、配送等)</li>
                  </ul>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <br class="clear" />
    </div>
  </div>
</template>
<script>
export default {
  setup() {},
};
</script>
